export default __webpack_public_path__ + "static/media/ECOHZ-EAC-Map.3b5c4560.jpg";